import { OpenInNew } from "@mui/icons-material";
import {
  Box,
  IconButton,
  OutlinedInput,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { BREADCRUMB_PAGE } from "components/Breadcrumb/constants";
import { MainLayoutContainer } from "components/Layout";
import { TagManager } from "components/TagManager";
import { useGetResourceByIdLazyQuery } from "graphql/__generated__/hooks";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Resource } from "types/resource";

export const ResourceDetail = () => {
  const { resourceId } = useParams();
  const [getResource, { data }] = useGetResourceByIdLazyQuery();

  useEffect(() => {
    if (resourceId) {
      getResource({ variables: { resourceId } });
    }
  }, [resourceId]);

  const resource = useMemo(() => {
    return data?.resource_by_pk as Resource;
  }, [data]);

  if (!resource) return <div>Loading...</div>;

  return (
    <MainLayoutContainer
      title={resource.name || "Resource Detail"}
      breadcrumb={BREADCRUMB_PAGE.RESOURCE}
      maxWidth={760}
    >
      <Box>
        <Box mt={2}>
          <Typography>{resource.description}</Typography>
        </Box>
        {resource?.tags && resource?.tags.length > 0 && (
          <Box mt={2}>
            <Stack spacing={1} direction={"row"} alignItems={"center"}>
              <Typography gutterBottom component="div" fontWeight={600}>
                Tags:
              </Typography>
              <TagManager
                tags={resource?.tags.map((t) => t.tag)}
                isEditing={false}
              />
            </Stack>
          </Box>
        )}
        <Box mt={2}>
          <Stack spacing={1} direction={"row"} alignItems={"center"}>
            <Typography gutterBottom component="div" fontWeight={600}>
              Url:
            </Typography>
            <OutlinedInput
              size="small"
              value={resource.url}
              readOnly
              fullWidth
            />
            <Tooltip title="Open link in a new tab">
              <IconButton
                component={"a"}
                // variant="contained"
                aria-label="directions"
                color="primary"
                href={resource.url}
                target="_blank"
              >
                <OpenInNew />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      </Box>
    </MainLayoutContainer>
  );
};
